import Table from '@/common/Table';
import Tippy from '@tippyjs/react';
import { Button } from 'react-bootstrap';

export type CustomInvoiceTableProps = {
  onDelete?: (id?: string) => () => void;
};

const CustomInvoiceTableHeader = ({ onDelete }: CustomInvoiceTableProps): JSX.Element => {
  return (
    <Table.Row header>
      <Table.Cell className="DELETE">
        <Tippy content="Delete All">
          <Button name="REMOVE_EMAIL" className="p-0" variant="icon" onClick={onDelete()} tabIndex={-1}>
            <i className="fa fa-trash text-danger" />
          </Button>
        </Tippy>
      </Table.Cell>
      <Table.Cell className="INDEX">No.</Table.Cell>
      <Table.Cell className="ITEM_TYPE">Item Type</Table.Cell>
      <Table.Cell className="NOTES">Notes</Table.Cell>
      <Table.Cell className="COST">Cost</Table.Cell>
    </Table.Row>
  );
};

export default CustomInvoiceTableHeader;
